import React, { useState, useEffect } from "react";
import { API } from "../constants/config";

const GD = "#064E3B";
const GOLD = "#D4AF37";
const BG = "#FDFBF7";

const JI_COLOR = { "吉": "#064E3B", "凶": "#c0392b", "中": "#6b5c3e" };
const JI_BG    = { "吉": "rgba(6,78,59,0.07)", "凶": "rgba(192,57,43,0.07)", "中": "rgba(107,92,62,0.06)" };

// Grid order: top-left to bottom-right (SE, S, SW, E, C, W, NE, N, NW) = palaces 4,9,2,3,5,7,8,1,6
const GRID_ORDER = [4, 9, 2, 3, 5, 7, 8, 1, 6];

export default function QimenPage({ user, lang = "zh", setPage }) {
  const [form, setForm] = useState({
    birth_year: new Date().getFullYear(), birth_month: new Date().getMonth() + 1,
    birth_day: new Date().getDate(), birth_hour: new Date().getHours(),
    birth_minute: 0, concern: "",
  });
  const [chart, setChart] = useState(null);
  const [narrative, setNarrative] = useState("");
  const [nowChart, setNowChart] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nowLoading, setNowLoading] = useState(true);
  const [error, setError] = useState("");
  const [qmTrans, setQmTrans] = useState({ doors: {}, stars: {}, spirits: {} });

  useEffect(() => {
    if (setPage) setPage("qimen");
    // Load current time chart + translations on mount
    fetch(`${API}/qimen/now`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data) setNowChart(data); })
      .catch(() => {})
      .finally(() => setNowLoading(false));
  }, []);

  const token = localStorage.getItem("lumina_token") || sessionStorage.getItem("lumina_token") || localStorage.getItem("token") || "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) { setError("请先登录（L1+）后使用奇门排盘"); return; }
    setLoading(true); setError(""); setChart(null); setNarrative("");
    try {
      const r = await fetch(`${API}/audit/qimen`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(form),
      });
      const data = await r.json();
      if (r.ok) { setChart(data.chart); setNarrative(data.narrative || "");
        if (data.translations) setQmTrans(data.translations); }
      else { setError(data.detail || "排盘失败，请稍后再试"); }
    } catch { setError("网络错误，请稍后再试"); }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: "32px 16px", background: BG, minHeight: "80vh" }}>
      <h1 style={{ fontSize: 26, fontWeight: 700, color: GD, marginBottom: 4 }}>奇门遁甲排盘</h1>
      <p style={{ color: "#6b5c3e", fontSize: 13, marginBottom: 28 }}>
        时辰级行动建议 · 阳遁阴遁 · 九宫八门
      </p>

      {/* Now chart — hidden when user submits their own chart to avoid dual-chart confusion */}
      {nowChart && !chart && (
        <div style={{ marginBottom: 28, padding: "14px 18px", background: "rgba(212,175,55,0.08)", border: `1px solid rgba(212,175,55,0.25)`, borderRadius: 10 }}>
          <div style={{ fontSize: 12, color: GOLD, letterSpacing: 1, marginBottom: 6 }}>当前时辰 · {nowChart.timestamp_cst}</div>
          <div style={{ fontSize: 13, color: "#4a3a1e" }}>{nowChart.action_summary}</div>
          <div style={{ fontSize: 11, color: "#9a8060", marginTop: 4 }}>
            {nowChart.chart?.yin_yang_dun} 第{nowChart.chart?.ju_shu}局 · {nowChart.chart?.solar_term}{nowChart.chart?.yuan} · 值符：{nowChart.chart?.zhifu_xing} · 值使：{nowChart.chart?.zhishi_men}
            {nowChart.chart?.horse_branch && ` · 🐴马星：${nowChart.chart.horse_branch}`}
            {nowChart.chart?.xun_kong?.length > 0 && ` · ⚡空亡：${nowChart.chart.xun_kong.join('、')}`}
          </div>
        </div>
      )}

      {/* Input form */}
      <form onSubmit={handleSubmit} style={{ background: "#fff", borderRadius: 12, padding: 20, border: `1px solid rgba(6,78,59,0.12)`, marginBottom: 28 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: GD, marginBottom: 14 }}>排盘（输入时辰）</div>
        {error && <div style={{ background: "rgba(192,57,43,0.06)", color: "#c0392b", padding: "8px 12px", borderRadius: 6, fontSize: 13, marginBottom: 12 }}>{error}</div>}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 10, marginBottom: 12 }}>
          {[
            ["年", "birth_year", "number", 1900, 2100],
            ["月", "birth_month", "number", 1, 12],
            ["日", "birth_day", "number", 1, 31],
            ["时", "birth_hour", "number", 0, 23],
            ["分", "birth_minute", "number", 0, 59],
          ].map(([label, key, type, min, max]) => (
            <div key={key}>
              <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 3 }}>{label}</label>
              <input type={type} min={min} max={max} value={form[key]}
                onChange={e => setForm({ ...form, [key]: parseInt(e.target.value) || 0 })}
                style={{ width: "100%", padding: "7px 8px", border: "1px solid rgba(0,0,0,0.12)", borderRadius: 6, fontSize: 13, boxSizing: "border-box" }} />
            </div>
          ))}
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 3 }}>所问之事（选填）</label>
          <input value={form.concern} onChange={e => setForm({ ...form, concern: e.target.value })}
            placeholder="如：今天下午适合签合同吗？" maxLength={200}
            style={{ width: "100%", padding: "8px 10px", border: "1px solid rgba(0,0,0,0.12)", borderRadius: 6, fontSize: 13, boxSizing: "border-box" }} />
        </div>
        <button type="submit" disabled={loading}
          style={{ padding: "9px 24px", background: loading ? "#9ca3af" : GD, color: "#fff", border: "none", borderRadius: 8, fontSize: 14, cursor: loading ? "not-allowed" : "pointer", fontWeight: 600 }}>
          {loading ? "排盘中…" : "开始排盘"}
        </button>
      </form>

      {/* Chart result */}
      {chart && (
        <div>
          <ChartMeta chart={chart} qmTrans={qmTrans} />
          {narrative && (
            <div style={{ marginBottom: 20, fontSize: 14, color: "#2d4a3e", lineHeight: 1.8 }}>
              <div style={{ fontSize: 11, color: GD, letterSpacing: 1, marginBottom: 8 }}>AI 解读</div>
              {narrative}
            </div>
          )}
          <QimenGrid chart={chart} qmTrans={qmTrans} />
        </div>
      )}
    </div>
  );
}


function ChartMeta({ chart, qmTrans }) {
  return (
    <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16, fontSize: 13 }}>
      {[
        ["遁", chart.yin_yang_dun],
        ["局", `第${chart.ju_shu}局`],
        ["节气", `${chart.solar_term}${chart.yuan}`],
        ["日柱", chart.ganzhi?.day],
        ["时柱", chart.ganzhi?.hour],
        ["值符", chart.zhifu_xing, qmTrans.stars?.[chart.zhifu_xing]],
        ["值使", chart.zhishi_men, qmTrans.doors?.[chart.zhishi_men]],
      ].map(([k, v, tip]) => (
        <span key={k} title={tip || ""} style={{ padding: "3px 10px", background: "rgba(6,78,59,0.07)", borderRadius: 10, color: GD, cursor: tip ? "help" : "default" }}>
          <span style={{ fontSize: 10, opacity: 0.7, marginRight: 4 }}>{k}</span>{v}
          {tip && <span style={{ fontSize: 9, opacity: 0.5, marginLeft: 4, fontStyle: "italic" }}>{tip.slice(0, 20)}…</span>}
        </span>
      ))}
    </div>
  );
}


function QimenGrid({ chart, qmTrans }) {
  const palaces = chart.palaces || {};
  return (
    <div>
      <div style={{ fontSize: 12, color: "#888", letterSpacing: 1, marginBottom: 10 }}>九宫排盘</div>
      <div style={{
        display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 6,
        maxWidth: 600, margin: "0 auto",
      }}>
        {GRID_ORDER.map(num => {
          const p = palaces[String(num)] || palaces[num];
          if (!p) return <div key={num} style={{ height: 100 }} />;
          return <PalaceCell key={num} p={p} qmTrans={qmTrans} />;
        })}
      </div>
      <div style={{ fontSize: 11, color: "#bbb", textAlign: "center", marginTop: 10 }}>
        天盘星 · 人盘门 · 神盘神 · 地盘仪
      </div>
    </div>
  );
}


function PalaceCell({ p, qmTrans }) {
  const isCenter = p.number === 5;
  const isZhifu = p.is_zhifu;
  const isZhishi = p.is_zhishi;
  const isHorse = p.is_horse;
  const isVoid  = p.is_void;

  const borderColor = isZhifu ? GOLD : isZhishi ? "#e06c00" : isHorse ? "#2563eb" : isVoid ? "#9ca3af" : "rgba(6,78,59,0.15)";
  const bg = isCenter ? "rgba(6,78,59,0.03)"
    : isZhifu ? "rgba(212,175,55,0.08)"
    : isZhishi ? "rgba(224,108,0,0.06)"
    : isVoid ? "rgba(156,163,175,0.06)"
    : "#fff";

  const menJi = p.renpan_men ? (["休","生","开"].includes(p.renpan_men) ? "吉" : ["伤","死","惊"].includes(p.renpan_men) ? "凶" : "中") : "中";

  return (
    <div style={{
      border: `1.5px solid ${borderColor}`,
      borderRadius: 8, background: bg, padding: "8px 6px",
      display: "flex", flexDirection: "column", alignItems: "center", gap: 3,
      minHeight: 110, position: "relative",
    }}>
      {/* Palace name + direction + markers */}
      <div style={{ fontSize: 10, color: "#888", alignSelf: "stretch", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontWeight: 700, color: GD }}>{p.name}</span>
        <span style={{ display: "flex", gap: 2, alignItems: "center" }}>
          {isHorse && <span title="马星" style={{ fontSize: 11 }}>🐴</span>}
          {isVoid  && <span title="空亡" style={{ fontSize: 11 }}>⚡</span>}
          <span>{p.direction}</span>
        </span>
      </div>

      {/* 天盘星 */}
      {p.tianpan_xing && (
        <div title={qmTrans.stars?.[p.tianpan_xing] || ""} style={{ fontSize: 13, fontWeight: 700, color: isZhifu ? "#8B6914" : GD, cursor: qmTrans.stars?.[p.tianpan_xing] ? "help" : "default" }}>
          {p.tianpan_xing}
          {isZhifu && <span style={{ fontSize: 9, marginLeft: 2, color: GOLD }}>值符</span>}
        </div>
      )}

      {/* 人盘门 */}
      {p.renpan_men && (
        <div title={qmTrans.doors?.[p.renpan_men] || ""} style={{
          fontSize: 14, fontWeight: 700,
          color: JI_COLOR[menJi], background: JI_BG[menJi],
          borderRadius: 4, padding: "1px 6px",
        }}>
          {p.renpan_men}门
          {isZhishi && <span style={{ fontSize: 9, marginLeft: 2, color: "#e06c00" }}>值使</span>}
        </div>
      )}

      {/* 神盘神 */}
      {p.shenpan_shen && (
        <div title={qmTrans.spirits?.[p.shenpan_shen] || ""} style={{ fontSize: 10, color: "#6b5c3e", cursor: qmTrans.spirits?.[p.shenpan_shen] ? "help" : "default" }}>{p.shenpan_shen}</div>
      )}

      {/* 地盘奇仪 */}
      {p.dipan_gan && (
        <div style={{ fontSize: 12, fontWeight: 600, color: ["乙","丙","丁"].includes(p.dipan_gan) ? "#8B6914" : "#444", marginTop: 2 }}>
          {p.dipan_gan}
        </div>
      )}

      {/* Trigram */}
      {p.trigram && (
        <div style={{ fontSize: 14, opacity: 0.25, position: "absolute", bottom: 4, right: 6 }}>{p.trigram}</div>
      )}
    </div>
  );
}
